import type { FC } from 'react';
import { Button } from '@shared/components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { ExportInvoicesViewArgs, useExportInvoicesView } from '../../hooks/useExportInvoicesView';

export type DownloadExcelButtonProps = ExportInvoicesViewArgs;

export const DownloadExcelButton: FC<DownloadExcelButtonProps> = (props) => {
  const { t } = useTranslation('invoicesViewModule');
  const { exportInvoicesView, isExporting } = useExportInvoicesView();

  const handleExport = () => {
    exportInvoicesView(props);
  };

  return (
    <Button
      onClick={handleExport}
      disabled={isExporting}
      type="button"
      size="sm"
      variant="outline"
      title={t('export.buttonTitle', 'Exportar a Excel')}
      className={`!py-[9px] !px-2 !text-icons transition-opacity duration-200 ${
        isExporting ? 'opacity-60 pointer-events-none' : ''
      }`}
      data-testid="export-excel-button"
    >
      <FontAwesomeIcon icon={faFileArrowDown} />
    </Button>
  );
};
